const t = {
  MODE: "development",
  CDN_URL: "https://cdn.devinflearn.com",
  API_URL: "https://www.devinflearn.com",
  SITE_URL: "https://www.devinflearn.com",
  MENTORING_SITE_URL: "https://mentoring.devinflearn.com",
  SOCIAL_ACCOUNT_URL: "https://account.devinflearn.com",
  ACCOUNT_API_URL: "https://account-api.devinflearn.com",
  COURSE_API_URL: "https://course-api.devinflearn.com",
  UCC_API_URL: "https://ucc-api.devinflearn.com",
  RALLIT_SITE_URL: "https://www.devrallit.com",
  BUSINESS_DOMAIN: "https://business.devinflearn.com",
  ADMIN_DOMAIN: "https://admin.devinflearn.com",
  COOKIE_DOMAIN: ".devinflearn.com",
  OAUTH_APPLE_CLIENT_ID: "com.inflab.inflearn.test",
  OAUTH_GITHUB_CLIENT_ID_LEGACY: "65fef69e7b3b778bd124",
  OAUTH_GITHUB_CLIENT_ID: "41f342acfada922e9fb5",
  OAUTH_GOOGLE_CLIENT_ID: "333892070963-abo0eoss3ielmeukj8dtvpr4l0fbniun.apps.googleusercontent.com",
  OAUTH_KAKAO_REST_ID: "1281a93457d30e1f2ffafe9fe0c197ab",
  HACKLE_BROWSER_SDK_KEY: "ygFNanOzYS2M5JgfrE5gUk69EbkFIzZ4",
  MIXPANEL_TOKEN: "2df837e504078b475f90b32d9a268c01",
  CDN_INTEGRATION_URL: "https://cdn.devinflab.com"
}, e = {
  MODE: "localhost",
  CDN_URL: "https://cdn.devinflearn.com",
  API_URL: "http://localhost:3000",
  SITE_URL: "http://localhost:3000",
  MENTORING_SITE_URL: "https://mentoring.devinflearn.com",
  SOCIAL_ACCOUNT_URL: "https://account.devinflearn.com",
  ACCOUNT_API_URL: "https://account-api.devinflearn.com",
  COURSE_API_URL: "https://course-api.devinflearn.com",
  UCC_API_URL: "https://ucc-api.devinflearn.com",
  RALLIT_SITE_URL: "https://www.devrallit.com",
  BUSINESS_DOMAIN: "http://localhost:7020",
  ADMIN_DOMAIN: "http://localhost:7010",
  COOKIE_DOMAIN: "localhost",
  OAUTH_APPLE_CLIENT_ID: "com.inflab.inflearn.test",
  OAUTH_GITHUB_CLIENT_ID_LEGACY: "65fef69e7b3b778bd124",
  OAUTH_GITHUB_CLIENT_ID: "41f342acfada922e9fb5",
  OAUTH_GOOGLE_CLIENT_ID: "333892070963-abo0eoss3ielmeukj8dtvpr4l0fbniun.apps.googleusercontent.com",
  OAUTH_KAKAO_REST_ID: "1281a93457d30e1f2ffafe9fe0c197ab",
  HACKLE_BROWSER_SDK_KEY: "ygFNanOzYS2M5JgfrE5gUk69EbkFIzZ4",
  MIXPANEL_TOKEN: "2df837e504078b475f90b32d9a268c01",
  CDN_INTEGRATION_URL: "https://cdn.devinflab.com"
}, I = {
  MODE: "production",
  CDN_URL: "https://cdn.inflearn.com",
  API_URL: "https://www.inflearn.com",
  SITE_URL: "https://www.inflearn.com",
  MENTORING_SITE_URL: "https://mentoring.inflearn.com",
  SOCIAL_ACCOUNT_URL: "https://account.inflearn.com",
  ACCOUNT_API_URL: "https://account-api.inflearn.com",
  COURSE_API_URL: "https://course-api.inflearn.com",
  UCC_API_URL: "https://ucc-api.inflearn.com",
  RALLIT_SITE_URL: "https://www.rallit.com",
  BUSINESS_DOMAIN: "https://business.inflearn.com",
  ADMIN_DOMAIN: "https://admin.inflearn.com",
  COOKIE_DOMAIN: ".inflearn.com",
  OAUTH_APPLE_CLIENT_ID: "com.inflab.inflearn.web",
  OAUTH_GITHUB_CLIENT_ID_LEGACY: "5fd8e44b142806d9cbea",
  OAUTH_GITHUB_CLIENT_ID: "419780d6d3750d84d1db",
  OAUTH_GOOGLE_CLIENT_ID: "887875630717-ror9t8ig4obhvokdij07eoochpqbu5kf.apps.googleusercontent.com",
  OAUTH_KAKAO_REST_ID: "0de1184063abadc9cef9dbf417c567a5",
  HACKLE_BROWSER_SDK_KEY: "rb1wDPCB39swIGfTAhDcz0QXvmh6hayS",
  MIXPANEL_TOKEN: "c05d8cc017a29af05e50c0d43d848d2d",
  CDN_INTEGRATION_URL: "https://cdn.inflab.com"
};
function o() {
  return typeof window < "u" && (window != null && window.env) ? window.env : process.env.NEXT_PUBLIC_ENV || process.env.APP_ENV;
}
function E() {
  const n = o();
  return n ? n === "localhost" ? e : n === "production" ? I : t : (console.error("app-shell env is not defined"), I);
}
const _ = E(), A = _.CDN_URL, O = _.SITE_URL, a = _.MENTORING_SITE_URL, T = _.SOCIAL_ACCOUNT_URL, c = _.API_URL, s = `${c}/api`, N = _.ACCOUNT_API_URL, L = _.COURSE_API_URL, U = _.UCC_API_URL, C = _.MODE, R = _.RALLIT_SITE_URL, f = _.OAUTH_APPLE_CLIENT_ID, i = _.OAUTH_GITHUB_CLIENT_ID, r = _.OAUTH_GOOGLE_CLIENT_ID, l = _.OAUTH_KAKAO_REST_ID, d = _.BUSINESS_DOMAIN, D = _.COOKIE_DOMAIN, p = _.HACKLE_BROWSER_SDK_KEY, S = _.MIXPANEL_TOKEN;
_.CDN_INTEGRATION_URL;
export {
  c as A,
  d as B,
  A as C,
  p as H,
  a as M,
  l as O,
  R,
  O as S,
  S as a,
  D as b,
  C as c,
  T as d,
  i as e,
  r as f,
  f as g,
  s as h,
  N as i,
  L as j,
  U as k
};
